import $ from 'jquery';

function initSelectedColumn() {

  $('.category_check_box').on('click', function(event) {
    var target = "input[type=checkbox]." + $(this).data('category') + "_item";
    
    if ($(target).length == $(target + ':checked').length) {
      $(target).prop("checked", false);
    } else {
      $(target).prop("checked", true);
    }
  });

}

export default initSelectedColumn